import { BellRing, Brain, Camera, MessageSquareHeart, QrCode, ScanSearch, Smartphone } from 'lucide-react';
import type { QuestCategory } from './types';

const ICONS: Record<QuestCategory, typeof QrCode> = {
  qr: QrCode,
  external: ScanSearch,
  photo: Camera,
  quiz: Brain,
  feedback: MessageSquareHeart,
  install: Smartphone,
  push: BellRing,
};

const COLOR: Record<QuestCategory, string> = {
  qr: 'text-cat-qr bg-cat-qr/15',
  external: 'text-cat-external bg-cat-external/15',
  photo: 'text-cat-photo bg-cat-photo/15',
  quiz: 'text-cat-quiz bg-cat-quiz/15',
  feedback: 'text-cat-feedback bg-cat-feedback/15',
  install: 'text-cat-install bg-cat-install/15',
  push: 'text-cat-push bg-cat-push/15',
};

export interface CategoryChipProps {
  category: QuestCategory;
  /** Localized category name — used as the accessible name. */
  label: string;
  className?: string;
}

/**
 * Quest-category identity chip (brief §4): 40px rounded square (12px radius),
 * 20px Lucide icon in the category color on a 15%-alpha tint of the same color.
 * The chip keeps its hue in every quest state.
 */
export function CategoryChip({ category, label, className = '' }: CategoryChipProps) {
  const Icon = ICONS[category];
  return (
    <span
      role="img"
      aria-label={label}
      data-testid="ec-category-chip"
      data-category={category}
      className={`flex size-10 shrink-0 items-center justify-center rounded-(--radius-chip) ${COLOR[category]} ${className}`}
    >
      <Icon size={20} strokeWidth={2} aria-hidden />
    </span>
  );
}
